import { Component, Injector, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { ParentModule } from 'app/pages/A2-utils/ParentClass/parent-module';
import { T2CardComponent } from 'app/trip2-theme/components/t2-card/t2-card.component';
import { BillingScheduleService } from 'app/utils/billing-scheduled-edit/billing-schedule.service';
import { BtnsForGridService } from 'app/utils/btns-for-grid/btns-for-grid.service';
import { getSelectNodeAfterFilter } from 'app/utils/helpers';
import { PaginatorCustomService } from 'app/utils/paginator-custom/paginator-custom.service';
import { _currencyFormat } from 'app/utils/trip2-query-builder/utils/helpers';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { BilledService } from '../billed.service';
import { GridLayoutStore, moduleActionIdOf } from 'app/utils/grid-layout-menu/grid-layout-store';

@Component({
  selector: 'app-mass-movement-grid',
  templateUrl: './mass-movement-grid.component.html',
  styleUrls: ['./mass-movement-grid.component.scss']
})
export class MassMovementGridComponent extends ParentModule  implements OnInit, OnDestroy {

  protected tripDataPR: any = [];
  protected tripid = 0;
  protected openTripPRModal = false;
  gridOptions: GridOptions;
  subscriptions: Subscription[] = [];
  dataCurrentModule: any = {};
  @ViewChild('modalEditScheduled') modalEditScheduled: T2CardComponent;
  @ViewChild('modalTripsPayroll') modalTripsPayroll: T2CardComponent;

  constructor(
    private billedService: BilledService,
    private billingScheduleService: BillingScheduleService,
    private paginatorCustomService: PaginatorCustomService,
    private btnsForGridService: BtnsForGridService,
    protected Inject: Injector,
    private sweetAlertHelper: SweetAlertHelper,
    private layoutStore: GridLayoutStore,
  ) {
    super('app-billed', Inject);
    this.initGrid();
  }

  ngOnInit() {
    this.observable();
    this.initLayoutMenu();
  }

  private initLayoutMenu() {
    this.subscriptions.push(this.layoutStore.follow(this.actionsList$, () => ({
      grid: this.gridOptions,
      moduleActionId: moduleActionIdOf(this.dataCurrentModule, 'MassMovementGrid'),
      title: 'Billed Mass Movement'
    })));
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  observable() {
    this.paginatorCustomService.getRowSelected(null);
    this.subscriptions.push(
      this.billedService.dataMovement$.subscribe((data: any) => {
        if (data && this.gridOptions.api) {
          this.gridOptions.api.setRowData(data);
        }
      })
    );
    this.subscriptions.push(
      this.billedService.scheduelEvent.subscribe((event) => {
        if (event && event.event) {
          this.modalEditScheduled.open();
        }
      })
    );
    this.subscriptions.push(
      this.billingScheduleService.modalClosed.subscribe((event) => {
        if (event) {
          this.modalEditScheduled.close();
        }
      })
    );
    this.subscriptions.push(
      this.billingScheduleService.eventSave.subscribe((event) => {
        if (event && this.gridOptions.api) {
          this.gridOptions.api.deselectAll();
        }
      })
    );

    this.subscriptions.push(
      this.btnsForGridService.clearFilterGrid$.subscribe((filter) => {
        if (filter && this.gridOptions.api) {
          const filterForGrid = {
            'filter': () => this.gridOptions.api.setFilterModel(null),
            'sort': () => this.gridOptions.api.setSortModel(null),
            'saveLayoutGrid': () => this.saveLayout()
          };
          return filterForGrid[filter]();
        }
      })
    );
    this.subscriptions.push(
      this.actionsList$.subscribe(() => {
        this.disabledSaveLayout(this.isAllowedAction('MassMovementGrid'));
      })
    );
    this.subscriptions.push(this.actions.asObservable().subscribe((res) => {
      if (res) {
        this.dataCurrentModule = res;
        this.getLayout();
      }
    }));
    this.subscriptions.push(
      this.billedService.exporToExcel.subscribe((res: boolean) => {
        if (res && this.gridOptions.api) {
          this.gridOptions.api.exportDataAsExcel({ sheetName: 'mass-move', fileName: 'mass-move' });
        }
      })
    );
  }

  disabledSaveLayout(disabledBtn): void {
    this.btnsForGridService.btnDisabled({ type: 'layout', disabled: disabledBtn });
  }


  initGrid() {
    this.gridOptions = <GridOptions>{
      enableColResize: true,
      enableFilter: true,
      enableSorting: true,
      rowSelection: 'multiple',
      columnDefs: [
        {
          allowContextMenuWithControlKey: true,
          headerName: '',
          width: 30,
          checkboxSelection: true,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true
        },
        {
          headerName: 'Date',
          field: 'dateofservice',
          width: 140,
          valueGetter: (params) => {
            if (params && params.data) {
              return this.formatterDate(params.data.dateofservice);
            }
          },
        },
        {
          headerName: 'Reservation',
          field: 'consecutive',
          cellStyle: { textAlign: 'right' },
          width: 160,
        },
        {
          headerName: 'Rider',
          field: 'ridernameformatgeneral',
        },
        {
          headerName: 'Gender',
          field: 'gender',
          width: 120,
        },
        {
          headerName: 'Member Id',
          field: 'memberid',
        },
        {
          headerName: 'DOB',
          field: 'dob',
          valueGetter: (params) => {
            if (params && params.data) {
              return this.formatterDate(params.data.dob);
            }
          },
        },
        {
          headerName: 'Payor',
          field: 'payor',
        },
        {
          headerName: 'Aging',
          field: 'aging',
          width: 250,
          valueGetter: (params) => {
            if (params && params.data) {
              return this.formatterDate(params.data.aging);
            }
          },
        },
        {
          headerName: 'Call Type',
          field: 'calltype',
        },
        {
          headerName: 'Leg',
          field: 'leg',
          width: 90,
        },
        {
          headerName: 'Event',
          field: 'event',
          width: 250,
        },
        {
          headerName: 'Schedule Name',
          field: 'schedulename',
          width: 250,
        },
        {
          headerName: 'Total Amount',
          field: 'totalamount',
          cellStyle: { textAlign: 'right' },
          width: 170,
          cellRenderer: this.formatterAmountMoney,
        },
        {
          headerName: 'Total Miles',
          field: 'totalmiles',
          cellStyle: { textAlign: 'right' },
          width: 150,
        },
        {
          headerName: 'Trip Status',
          field: 'tripstatus',
          cellStyle: { textAlign: 'right' },
          width: 150,
        },
        {
          headerName: 'Billing Status',
          field: 'billingstatus',
          cellStyle: { textAlign: 'right' },
          width: 150,
        },
      ],
      onGridReady: () => {
        this.gridOptions.api.setRowData([]);
        this.gridOptions.api.sizeColumnsToFit();
      },
      onSelectionChanged: () => {
        if (this.gridOptions && this.gridOptions.api) {
          const selectedRows = getSelectNodeAfterFilter(this.gridOptions);
          this.billedService.scheduelEvent.emit({ disabled: !!selectedRows.length });
          this.billingScheduleService.getFormData(selectedRows);
          this.paginatorCustomService.getRowSelected(selectedRows.length);
        }
      },
      onFilterChanged: (params) => {
        if (params && params.api) {
          this.btnsForGridService.btnDisabled({ type: 'filter', disabled: params.api['filterManager'].advancedFilterPresent });
        }
      },
      onSortChanged: () => {
        const sort = this.gridOptions.api.getSortModel();
        this.btnsForGridService.btnDisabled({ type: 'sort', disabled: !!sort.length });
      },
      onRowDoubleClicked: (params) => {
        this.openTripsModal(params.data);
      }
    };
  }

  public openTripsModal(data) {
    this.tripDataPR = data;
    this.tripid = data.tripid;
    this.modalTripsPayroll.open();
    this.openTripPRModal = true;
  }

  formatterAmountMoney = (params: any) => {
    const value = params && params.value ? params.value : 0;
    return _currencyFormat(value);
  }

  formatterDate(params) {
    if (params) {
      return moment(params).format('MM-DD-YYYY');
    }
  }

  getLayout(): void {
    const moduleId = this.dataCurrentModule.moduleid;
    this.subscriptions.push(
      this.billedService.getRoleActionByModule(moduleId).subscribe(
        data => {
          data.forEach((val: any) => {
            if (val.action.description === 'MassMovementGrid' && val.layout) {
              this.gridOptions.columnApi.setColumnState(JSON.parse(val.layout.config));
            }
          });
        }, (error) => {
          this.sweetAlertHelper.captureException(error).then(() => {
          });
        }
      ));
  }

  saveLayout(): void {
    if (this.gridOptions.columnApi.getColumnState().length) {
      const MODULE_ACTION_ID = this.dataCurrentModule.actions.MassMovementGrid.moduleactionid;
      const stringLayout = JSON.stringify(this.gridOptions.columnApi.getColumnState());
      const data = { moduleactionid: MODULE_ACTION_ID, config: stringLayout };
      this.btnsForGridService.saveLayoutGrid(data);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/billing-general/billed/mass-movement-grid/mass-movement-grid.component.ts